import {
    createRouter,
    createWebHistory,
    createWebHashHistory
} from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Home from '../views/Home/index.vue'

const routes = [
    // {
    //     path: '/',
    //     name: 'Welcome',
    //     component: function() {
    //         return import('../views/welcome/index.vue')
    //     },
    // },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/product',
        name: 'Product',
        component: function() {
            return import('../views/Product/index.vue')
        },
    },
    {
        path: '/cooperation',
        name: 'Cooperation',
        component: function() {
            return import('../views/Cooperation/index.vue')
        },
    },
    {
        path: '/contactUs',
        name: 'ContactUs',
        component: function() {
            return import('../views/ContactUs/index.vue')
        },
    },
    {
        path: '/aboutUs',
        name: 'AboutUs',
        component: function() {
            return import('../views/AboutUs/index.vue')
        },
    },
    {
        path: '/certificate',
        name: 'Certificate',
        component: function() {
            return import('../views/Certificate/index.vue')
        },
    },

    // 移动端
    {
        path: '/Phone/product',
        name: 'phoneProduct',
        component: function() {
            return import('../views/Phone/Product/index.vue')
        },
    },
    {
        path: '/Phone/cooperation',
        name: 'phoneCooperation',
        component: function() {
            return import('../views/Phone/Cooperation/index.vue')
        },
    },
    {
        path: '/Phone/contactUs',
        name: 'phoneContactUs',
        component: function() {
            return import('../views/Phone/ContactUs/index.vue')
        },
    },
    {
        path: '/Phone/aboutUs',
        name: 'phoneAboutUs',
        component: function() {
            return import('../views/Phone/AboutUs/index.vue')
        },
    },
    {
        path: '/Phone/certificate',
        name: 'phoneCertificate',
        component: function() {
            return import('../views/Phone/Certificate/index.vue')
        },
    },

]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
})
router.afterEach(() => {
    NProgress.done();
})

export default router